<div class="flex flex-col lg:flex-row gap-4 md:gap-6 p-2 sm:p-4 md:p-6 bg-slate-100 min-h-screen relative" (click)="activeEditor = null">
  
  <!-- Sidebar Controls -->
  <div class="w-full lg:w-[400px] bg-white p-4 sm:p-6 rounded-2xl shadow-xl border border-gray-200 h-fit lg:sticky lg:top-6 z-20">
    <button (click)="goBack()" class="flex items-center gap-2 text-gray-400 hover:text-[#c19725] transition mb-4 group">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 transform group-hover:-translate-x-1 transition" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
      </svg>
      <span class="text-[10px] font-black uppercase tracking-[0.2em]">Back</span>
    </button>

    <div class="flex items-center gap-3 mb-6">
      <div class="w-2 h-8 bg-[#006269] rounded-full"></div>
      <h2 class="text-lg sm:text-xl font-black text-gray-800 uppercase tracking-tight">Estimate Design</h2>
    </div>
    
    <div class="space-y-6">
      <div class="bg-gray-50 p-4 sm:p-5 rounded-2xl space-y-4">
        <p class="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Theme & Row Colors</p>
        <div class="flex items-center justify-between">
            <label class="text-sm font-bold text-gray-700">Primary Theme</label>
            <input type="color" [(ngModel)]="invoiceSettings.colors.themeColor" class="w-10 h-8 rounded border-none cursor-pointer">
        </div>
        <div class="flex items-center justify-between">
            <label class="text-sm font-bold text-gray-700">Outer Frame</label>
            <input type="color" [(ngModel)]="invoiceSettings.colors.outerBorder" class="w-10 h-8 rounded border-none cursor-pointer">
        </div>
        <div class="flex items-center justify-between">
            <label class="text-sm font-bold text-gray-700">Total Row BG</label>
            <input type="color" [(ngModel)]="invoiceSettings.colors.totalRowBg" class="w-10 h-8 rounded border-none cursor-pointer">
        </div>
        <div class="flex items-center justify-between">
            <label class="text-sm font-bold text-gray-700">Packing Header BG</label>
            <input type="color" [(ngModel)]="invoiceSettings.colors.packagingHeaderBg" class="w-10 h-8 rounded border-none cursor-pointer">
        </div>
        <div class="flex items-center justify-between border-t pt-2">
            <label class="text-sm font-bold text-gray-700">Show Packing List</label>
            <input type="checkbox" [(ngModel)]="invoiceSettings.packaging.visible" class="accent-[#006269] w-5 h-5">
        </div>
      </div>

      <div class="pt-2 space-y-3">
        <button (click)="saveLayoutSettings()" class="w-full py-4 bg-[#006269] text-white rounded-2xl font-black shadow-lg hover:opacity-90 transition active:scale-95 uppercase tracking-widest text-sm">
          Save Layout
        </button>
        <button (click)="resetLayoutSettings()" class="w-full py-3 text-gray-400 font-bold hover:bg-gray-100 rounded-xl transition text-sm">
          Reset to Default
        </button>
      </div>
    </div>
  </div>

  <!-- Real-Time Estimate Preview -->
  <div class="flex-1 w-full lg:max-h-[calc(100vh-48px)] lg:overflow-y-auto scrollbar-hide overflow-x-hidden">
    
    <!-- CONTEXTUAL EDITOR POPUP -->
    <div *ngIf="activeEditor" [ngStyle]="editorPosition" class="fixed z-[100] bg-white p-5 shadow-2xl border border-gray-100 rounded-2xl w-72 max-w-[90vw] animate-in fade-in zoom-in duration-150" (click)="$event.stopPropagation()">
      <div class="flex justify-between items-center mb-4 border-b pb-2">
        <h4 class="text-[10px] font-black uppercase text-[#006269] tracking-widest">{{ activeEditorLabel }}</h4>
        <button (click)="activeEditor = null" class="text-gray-300 hover:text-red-500 transition">✕</button>
      </div>
      <div class="space-y-4">
        <div *ngIf="activeEditor.text !== undefined">
          <label class="text-[9px] font-bold text-gray-400 uppercase block mb-1">Display Text</label>
          <input [(ngModel)]="activeEditor.text" class="w-full border rounded-xl p-2.5 text-xs outline-none focus:ring-1 focus:ring-[#006269]">
        </div>
        <!-- UPDATED COLOR PICKER IN POPUP -->
        <div *ngIf="activeEditor.color !== undefined" class="flex justify-between items-center bg-gray-50 p-2.5 rounded-xl">
          <label class="text-[9px] font-bold text-gray-500 uppercase">Text Color</label>
          <input type="color" [(ngModel)]="activeEditor.color" class="w-8 h-8 rounded-full border-2 border-white shadow-sm cursor-pointer">
        </div>
        <div class="flex justify-between items-center bg-gray-50 p-2.5 rounded-xl">
          <label class="text-[9px] font-bold text-gray-500 uppercase">Visibility</label>
          <input type="checkbox" [(ngModel)]="activeEditor.visible" class="accent-[#006269] w-4 h-4">
        </div>
      </div>
    </div>

    <!-- The Mockup -->
    <div class="w-full max-w-5xl mx-auto bg-white shadow-2xl transition-all overflow-hidden" [style.border]="'5px solid ' + invoiceSettings.colors.outerBorder">
      <!-- Header -->
      <header class="p-4 sm:p-6 border-b-2 text-center" [style.borderColor]="invoiceSettings.colors.outerBorder">
        <h1 class="font-bold mb-2 cursor-pointer hover:bg-yellow-50 break-words leading-tight" 
            (click)="openEditor(invoiceSettings.header.mainTitle, 'Main Title', $event)"
            [style.color]="invoiceSettings.header.mainTitle.color"
            [style.fontSize.px]="invoiceSettings.header.mainTitle.fontSize">
          {{invoiceSettings.header.mainTitle.text}}
        </h1>
        <div class="flex flex-col sm:flex-row justify-between text-xs sm:text-sm text-gray-700 px-2 sm:px-8 gap-2">
          <p>
            <strong class="cursor-pointer hover:bg-yellow-50" 
                    (click)="openEditor(invoiceSettings.header.voucherLabel, 'Voucher Label', $event)"
                    [style.color]="invoiceSettings.header.voucherLabel.color">
                {{invoiceSettings.header.voucherLabel.text}}
            </strong> RE-001
          </p>
          <p>
            <strong class="cursor-pointer hover:bg-yellow-50" 
                    (click)="openEditor(invoiceSettings.header.dateLabel, 'Date Label', $event)"
                    [style.color]="invoiceSettings.header.dateLabel.color">
                {{invoiceSettings.header.dateLabel.text}}
            </strong> 29-01-2024
          </p>
        </div>
      </header>

      <!-- Main Product Table -->
      <section class="px-2 sm:px-6 py-4 overflow-x-auto">
        <table class="w-full text-xs sm:text-sm text-center border-collapse min-w-[600px]">
          <thead [style.backgroundColor]="invoiceSettings.colors.themeColor">
            <tr>
              <th *ngFor="let h of invoiceSettings.table.headers" 
                  class="p-2 border border-white/20 cursor-pointer hover:bg-black/10"
                  (click)="openEditor(h, 'Table Header', $event)"
                  [style.color]="h.color"
                  [class.hidden]="!h.visible">
                {{h.text}}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="p-2 border border-gray-300">1</td>
              <td class="p-2 border border-gray-300 text-left italic">Silver Chain</td>
              <td class="p-2 border border-gray-300">10.00</td>
              <td colspan="8" class="p-2 border border-gray-300">...</td>
            </tr>

            <!-- Total Row -->
            <tr class="font-semibold" [style.backgroundColor]="invoiceSettings.colors.totalRowBg">
              <td colspan="2" class="p-2 border border-gray-300 text-center cursor-pointer hover:bg-black/5" 
                  (click)="openEditor(invoiceSettings.summary.totalLabel, 'Total Label', $event)"
                  [style.color]="invoiceSettings.summary.totalLabel.color">
                {{invoiceSettings.summary.totalLabel.text}}
              </td>
              <td colspan="9" class="p-2 border border-gray-300">...</td>
            </tr>

            <!-- Silver Bhav Row -->
            <tr>
              <td colspan="2" class="p-2 border border-gray-300 text-left font-semibold cursor-pointer hover:bg-yellow-50"
                  (click)="openEditor(invoiceSettings.summary.silverValueLabel, 'Silver Label', $event)"
                  [style.color]="invoiceSettings.summary.silverValueLabel.color">
                {{invoiceSettings.summary.silverValueLabel.text}} 750
              </td>
              <td colspan="9" class="p-2 border border-gray-300"></td>
            </tr>

            <!-- Receipt Cash Row -->
            <tr>
              <td colspan="2" class="p-2 border border-gray-300 text-left font-semibold cursor-pointer hover:bg-yellow-50"
                  (click)="openEditor(invoiceSettings.summary.receiptCashLabel, 'Receipt Label', $event)"
                  [style.color]="invoiceSettings.summary.receiptCashLabel.color">
                {{invoiceSettings.summary.receiptCashLabel.text}}
              </td>
              <td colspan="9" class="p-2 border border-gray-300"></td>
            </tr>

            <!-- Closing Balance Row -->
            <tr class="font-bold" [style.backgroundColor]="invoiceSettings.colors.balanceRowBg">
              <td colspan="10" class="p-2 border border-gray-300 text-right cursor-pointer hover:bg-yellow-50"
                  (click)="openEditor(invoiceSettings.summary.closingBalanceLabel, 'Balance Label', $event)"
                  [style.color]="invoiceSettings.summary.closingBalanceLabel.color">
                {{invoiceSettings.summary.closingBalanceLabel.text}}
              </td>
              <td class="p-2 border border-gray-300" [style.color]="invoiceSettings.summary.closingBalanceLabel.color">₹ 0</td>
            </tr>
          </tbody>
        </table>
      </section>

      <!-- PACKAGING DETAILS SECTION -->
      <section *ngIf="invoiceSettings.packaging.visible" class="px-2 sm:px-6 pt-4 border-t border-gray-100 overflow-x-auto">
        <h3 class="font-semibold mb-2 text-xs sm:text-sm uppercase cursor-pointer hover:bg-yellow-50"
            (click)="openEditor(invoiceSettings.packaging.title, 'Packing Title', $event)"
            [style.color]="invoiceSettings.packaging.title.color">
          {{ invoiceSettings.packaging.title.text }}
        </h3>

        <table class="w-full text-xs sm:text-sm border-collapse border border-gray-300 min-w-[300px]">
          <thead [style.backgroundColor]="invoiceSettings.colors.packagingHeaderBg">
            <tr>
              <th *ngIf="invoiceSettings.packaging.headers.name.visible" 
                  class="p-2 border border-gray-300 text-left cursor-pointer hover:bg-black/5"
                  (click)="openEditor(invoiceSettings.packaging.headers.name, 'Name Header', $event)"
                  [style.color]="invoiceSettings.packaging.headers.name.color">
                {{ invoiceSettings.packaging.headers.name.text }}
              </th>
              <th *ngIf="invoiceSettings.packaging.headers.qty.visible" 
                  class="p-2 border border-gray-300 text-center cursor-pointer hover:bg-black/5"
                  (click)="openEditor(invoiceSettings.packaging.headers.qty, 'Qty Header', $event)"
                  [style.color]="invoiceSettings.packaging.headers.qty.color">
                {{ invoiceSettings.packaging.headers.qty.text }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td *ngIf="invoiceSettings.packaging.headers.name.visible" class="p-2 border border-gray-300">Sample Packing</td>
              <td *ngIf="invoiceSettings.packaging.headers.qty.visible" class="p-2 border border-gray-300 text-center">1</td>
            </tr>
          </tbody>
        </table>
      </section>

      <!-- Terms & Conditions -->
      <section class="px-4 sm:px-6 py-4 border-t border-gray-300 text-xs sm:text-sm text-gray-700 mt-4">
        <h2 class="font-bold mb-1 cursor-pointer hover:bg-yellow-50 uppercase tracking-tighter" 
            (click)="openEditor(invoiceSettings.footer.termsTitle, 'Terms Title', $event)"
            [style.color]="invoiceSettings.footer.termsTitle.color">
          {{invoiceSettings.footer.termsTitle.text}}
        </h2>
        <p class="cursor-pointer hover:bg-yellow-50 leading-relaxed" 
           (click)="openEditor(invoiceSettings.footer.termsText, 'Terms Content', $event)"
           [style.color]="invoiceSettings.footer.termsText.color">
          {{invoiceSettings.footer.termsText.text}}
        </p>
      </section>
    </div>
  </div>
</div>